<!--
 * @Author: your name
 * @Date: 2020-12-25 17:11:37
 * @LastEditTime: 2021-12-14 16:31:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \sso_admin_frontend\src\views\home\Home.vue
-->
<template>
  <div class="layout">
    <SideBar :isCollapsed="isCollapsed" ref="side"/>
    <Layout>
      <Header :style="{padding: 0}" class="layout-header-bar">
                  <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{margin: '0 20px'}" type="md-menu" size="24"></Icon>
        <span style="margin-left: 40%">管理配置</span>
        <a class="m-r" @click="logout"><Icon type="md-arrow-dropright" size="18"/>退出</a>
      </Header>
      <Content :style="{margin: '20px', background: '#fff', minHeight: '260px', padding: '30px 20px'}">
        <router-view/>
      </Content>
    </Layout>
  </div>
</template>

<script>
    import SideBar from "@/views/sideBar/index";
    import {Tools} from '@/assets/js/common';
    export default {
        name: "Home",
        components:{
            SideBar
        },
        data() {
            return {
                isCollapsed: false
            }
        },
        computed: {
          rotateIcon () {
            return [
              'menu-icon',
              this.isCollapsed ? 'rotate-icon' : ''
            ];
          }
        },
        methods:{
            collapsedSider () {
                this.isCollapsed = !this.isCollapsed;
              // this.$refs.side1.toggleCollapse();
            },
            logout() {
                Tools.cookie.removeCookie("token");
                Tools.cookie.removeCookie("username");
                if(window.location.host.includes('alpha')) {
                  window.location = `http://192.168.6.100.9090/cas/logout?service=${window.location.origin}/login` //alpha
                }else if(window.location.host.includes('sso-admin.')){
                    window.location = `https://sso.${window.location.host.split('.')[1]}.com/cas/logout?service=${window.location.origin}/login`//正式
                }else {
                  window.location = `https://sso-test.digi800.com/cas/logout?service=${window.location.origin}/login`//测试
                }
            }
        }
    }
</script>

<style scoped>
  .ivu-layout.ivu-layout-has-sider{
    height: 100vh;
  }
  .layout{
    width: 100%;
    height: 100vh;
    display: flex;
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  .layout-header-bar{
    background: #fff;
    box-shadow: 0 1px 1px rgba(0,0,0,.1);
  }
  .layout-logo-left{
    width: 90%;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    margin: 15px auto;
  }
  .menu-icon{
    transition: all .3s;
  }
  .rotate-icon{
    transform: rotate(-90deg);
  }
  .m-r{
    float: right;
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue